// auto-generated file!!!
export const VARS = {
  NG_SENTRY: 'TESTVARTESTAVAR'
};